const shadows = {
  0: "0px 1px 4px rgba(0, 0, 0, 0.1)",
  1: "0px 1px 4px rgba(0, 0, 0, 0.1)", // default MuiPaper
  2: "0px 4px 6px rgba(0, 0, 0, 0.06)",
  3: "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;", // PureToneGraph
};

export default shadows;
